// window.addEventListener("OpusCartChange", (e) => {
//   setInterval(() => {
//       const freeGiftBtn = document.querySelector(".opus-carousel-item .cd-buy-button");
//       if(freeGiftBtn) {
//         freeGiftBtn.innerHTML = "CHOOSE YOUR COLOR"
//       }
//   }, 500);
// })

const currentURL = window.location.pathname;

if (currentURL.endsWith("/cart")) {
localStorage.setItem("opusOpenCustom", "true");
window.location.replace("https://emmakate.store");
}

document.addEventListener("DOMContentLoaded", function () {
if (localStorage.getItem("opusOpenCustom")) {
    localStorage.removeItem("opusOpenCustom");
    setTimeout(() => {
    if (typeof window.opusOpen === "function") {
        window.opusOpen();
    }
    }, 1000);
}
});